import React from 'react';
import HeroSection from '../components/HeroSection';
import WelcomeSection from '../components/WelcomeSection';
import FoundationSection from '../components/FoundationSection';
import StructureWorkPackages from '../components/StructureWorkPackages';
import ContactForm from '../components/ContactForm';
import SubHero from '../components/SubHero';

const Home = () => {
  return (
    <div>
      <SubHero />
      <HeroSection />
      <WelcomeSection />
      <FoundationSection />
      <StructureWorkPackages />
      <ContactForm />
    </div>
  );
};

export default Home;